<app-dialog-header headerText="Modify Account" (onCloseClick)="onCancelClick()"></app-dialog-header>
<form [formGroup]="dialogForm">
	<div mat-dialog-content style="max-width: 500px;">
		<mat-form-field>
			<mat-label>Name:</mat-label>
			<input matInput autocomplete="off" formControlName="Name" required>
			<mat-error *ngIf="dialogForm.get('Name')!.hasError('required')">Name is required</mat-error>
		</mat-form-field>
		<mat-form-field>
			<mat-label>Description:</mat-label>
			<input matInput autocomplete="off" formControlName="Description">
			<mat-error *ngIf="dialogForm.get('Description')!.hasError('required')">Description is required</mat-error>
		</mat-form-field>
		<mat-form-field appearance="fill" *ngIf="accountUsers">
			<mat-label>Owner:</mat-label>
			<mat-select formControlName="OwnerID">
				<mat-option *ngFor="let User of accountUsers" title="Email:{{User.Email}}"
					[value]="User.UserID">{{User.Name}} <small *ngIf="User.Admin">*</small></mat-option>
			</mat-select>
		</mat-form-field>
		<mat-form-field>
			<mat-label>Address:</mat-label>
			<textarea matInput autocomplete="off" formControlName="Address" style="height: 5em;"></textarea>
			<mat-error *ngIf="dialogForm.get('Address')!.hasError('required')">Address is required</mat-error>
		</mat-form-field>
		<app-image-container imgURL="{{imagePathAccounts()}}{{dialogData.ID}}?{{numberRND}}"
			[enablePicture]="enablePicture" [enableCamera]="enableCamera" [enableDelete]="enableDelete"
			(onDelete)="deleteImg()" (onNewImage)="onNewImage($event)"></app-image-container>
		@if (thisUser.AdminSite) {
		<div class="md-form mb-1 matFormSlider">
			<div>
				<mat-label>Trial:</mat-label>
				<mat-slide-toggle #switchAutoBuild formControlName="Trial" color="primary"></mat-slide-toggle>
			</div>
		</div>
		
		<div class="md-form mb-1 matFormSlider">
			<div>
				<mat-label>Closed:</mat-label>
				<mat-slide-toggle #switchAutoBuild formControlName="Closed" color="primary"></mat-slide-toggle>
			</div>
		</div>
		<div class="md-form mb-1 matFormDate">
			<div>
				<mat-label>Account Expiry:</mat-label>
				<ejs-datepicker placeholder="Account Expiry Date" [firstDayOfWeek]="1" format="dd-MMM-yyyy"
					[dayHeaderFormat]="'Abbreviated'" formControlName="Expiry" [min]="today">
				</ejs-datepicker>
			</div>
		</div>
		}
	</div>
	<div mat-dialog-actions>
		<button mat-button (click)="onSaveClick()" [disabled]="dialogForm.invalid || !dialogForm.dirty">Ok</button>
		<button mat-button (click)="onCancelClick()" cdkFocusInitial>Cancel</button>
	</div>
</form>